import { Component, OnInit } from '@angular/core';
import { ReportdashboardService } from '../../services/reportdashboard.service';
import { ReportLock } from '../../models/report-lock.model';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-report-management',
  templateUrl: './report-management.component.html',
  styleUrls: ['./report-management.component.css']
})
export class ReportManagementComponent implements OnInit {
  lockedReports: ReportLock[];

  constructor(private _reportDashboardService: ReportdashboardService, private _notifier: NotifierService) {}

  ngOnInit() {
    this.getLockedReports();
  }

  getLockedReports() {
    this._reportDashboardService.getLockedReports().subscribe(reports => {
      console.log(reports);
      this.lockedReports = reports;
    });
  }

  unlockReport(report: ReportLock) {
    this._reportDashboardService.removeReportLock(report.reportId, report.token).subscribe(response => {
      console.log('unlocking report');
      if (response.ok) {
        this.getLockedReports();
        this._notifier.notify('success', 'Successfully unlocked report');
      }
    });
  }

  ///
  /// TODO: Additional Admin functionality for reports ///
  ///
}



// WEBPACK FOOTER //
// ./src/app/admin/report-management/report-management.component.ts